import React, { useState } from "react";
import { Message, Segment } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useParams, Redirect, useHistory, } from "react-router-dom";


import { PageTemplate } from "../components/PageTemplate/PageTemplate";
import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import { useCurrentObservationById } from "../store/selectors/observationSelectors";
import { isLoaded, isLoadErrored } from "../../../sg-core";
import ObservationEditing from "../components/observation/ObservationEditing";
import { MinimumCategoryPermission } from "../components/permissions/MinimumCategoryPermission";
import { useFormTypeById } from "../store/selectors/formSelectors";
import { EPermissionLevel } from "../interfaces/ICategoryPermission";
import { getRouteHrefById } from "../../../routing";
import { HavainnotRouteId } from "../../routes";



interface IEditObservationPage { };

const EditObservationPage: React.FC<IEditObservationPage> = (props) => {
    const { t } = useTranslation();
    const params = useParams<{ observation: string }>();
    const observationGuid = params.observation;

    const { allowEditingObservation } = useApplicationConfiguration()

    const [submitted, setSubmitted] = useState<boolean>(false);

    const observation = useCurrentObservationById(observationGuid);
    const formType = useFormTypeById(isLoaded(observation) ? observation.data.formType : undefined);

    const goBack = useHistory().goBack;

    if (submitted) {
        return (
            <Redirect to={getRouteHrefById(HavainnotRouteId.ObservationPage, { observation: observationGuid })!} />
        )
    };

    if (!allowEditingObservation) {
        return (
            <Redirect to={getRouteHrefById(HavainnotRouteId.ObservationPage, { observation: observationGuid })!} />
        )
    }

    if (!observationGuid) {
        return <Message content={t("Virhe ei valittua havaintoa")} negative />;
    }

    if (isLoadErrored(observation)) {
        return <Message content={t("Havainnon haku epäonnistui")} negative />;
    }

    if (!isLoaded(observation) || !formType) {
        return <Segment loading basic />;
    }

    return (
        <PageTemplate>
            <MinimumCategoryPermission
                categoryId={formType.category}
                minimumPermission={EPermissionLevel.OnlyPublic}
                permissionType="edit"
            >
                <ObservationEditing
                    observation={observation.data}
                    onSuccess={() => setSubmitted(true)}
                    onCancel={goBack}
                />
            </MinimumCategoryPermission>
        </PageTemplate>
    );
};

const MemoizedEditObservationPage = React.memo(EditObservationPage);

const EditObservationPageContainer: React.FC = () => {
    return <MemoizedEditObservationPage />;
};

export default EditObservationPageContainer;
